import React from "react"
import styled from "@emotion/styled"

import copyIcon from "../../../images/copy-icon.png"

const Copy = styled.img`
  width: 13px;
  height: 14px;
`

const CopyIcon = () => <Copy src={copyIcon} alt="copy" />

export default CopyIcon
